import classNames from "classnames";

export const TypeButton = ({ text, section, activeSection, setActiveSection}) =>{
    return (
        <button
            className={classNames({"selected": activeSection===section })}
            onClick={() => setActiveSection(section)}
        >
            {text}
        </button>
    )
}
